<template>
  <div v-if="loading">
    <div class="loading-panel">
      <i class="loadinfo fas fa-circle-notch" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
